import {
  concat,
  find,
  sum,
  map,
  filter,
  sortBy,
  sumBy,
  isEmpty,
  includes,
  orderBy,
  uniqBy,
  flatten,
} from "lodash";

export function calculateTotals(contingents) {
  return {
    amount: calculateTotalPrice(contingents),
    vat: calculateTotalVat(contingents),
  };
}

export function calculateTotalVat(contingents) {
  return sum(
    map(
      contingents.map(
        (contingent) =>
          contingent.price_gross * contingent.count -
          (contingent.price_gross * contingent.count) /
            (1 + contingent.vat_rate)
      )
    )
  );
}

export function optimizeImage(url, imageSize=400) {
    return `https://process.filestackapi.com/AZ40T6UWDRnGhMi7AH7kQz/resize=width:${imageSize},height:${imageSize}/output=f:jpg/compress/quality=v:94/${url}`;
}

export function calculateTotalPrice(contingents) {
  var total = sum(
    map(
      contingents.map((contingent) => contingent.price_gross * contingent.count)
    )
  );

  // TODO: implement me
  // if (this.convertFromPurchase && this.convertFromPurchase.conversion_fee) {
  //   total += this.convertFromPurchase.conversion_fee;
  // }

  return total;
}

export function calculateTotalTicketCountApplicableForTicketCountDiscountCodes(
  contingents
) {
  return sumBy(
    filter(
      contingents,
      (contingent) => !contingent.exclude_from_ticket_count_for_discount_codes
    ),
    "count"
  );
}

export function calculateTotalCount(contingents) {
  return sumBy(contingents, "count");
}

export function activeContingents(contingents) {
  return filter(contingents, (contingent) => !!contingent.count);
}

export function calculateCustomFieldsPerPurchase(
  contingents,
  defaultCustomFieldsPerPurchase
) {
  // Merge all questions from active contingents.
  const customFields = flatten(
    map(activeContingents(contingents), "custom_fields_per_purchase")
  );

  // Maybe unique by question name as well?
  const customFieldsPerPurchase = uniqBy(customFields, "id");
  return orderBy(
    concat(defaultCustomFieldsPerPurchase, customFieldsPerPurchase),
    ["created_at"],
    ["asc"]
  );
}

export function calculateApplicableDiscountCodes(
  contingents,
  automaticDiscountCodes,
  discountCodes
) {
  var totalTicketCount =
    calculateTotalTicketCountApplicableForTicketCountDiscountCodes(contingents);
  var totalPrice = calculateTotalPrice(contingents);

  let applicableAutomaticDiscountCodes = filter(
    automaticDiscountCodes,
    function (discountCode) {
      if (
        discountCode.ticket_count_min &&
        totalTicketCount < discountCode.ticket_count_min
      ) {
        return false;
      }

      if (
        discountCode.ticket_count_max &&
        totalTicketCount > discountCode.ticket_count_max
      ) {
        return false;
      }

      if (discountCode.amount_min && totalPrice < discountCode.amount_min) {
        return false;
      }

      if (discountCode.amount_max && totalPrice > discountCode.amount_max) {
        return false;
      }
      return true;
    }
  );

  // Need to sort these by best deal for user.
  return sortBy(
    concat(applicableAutomaticDiscountCodes, discountCodes),
    function (dc) {
      // We value relative amounts way higher, so we
      if (dc.type === "relative") {
        return -dc.amount * 1000000;
      }

      return -dc.amount;
    }
  );
}

export function orderByPrice(contingents) {
  return orderBy(contingents, ["price"], ["desc"]);
}

export function calculateTotalPriceIncludingDiscount(
  contingents,
  applicableDiscountCodes
) {
  if (isEmpty(applicableDiscountCodes)) {
    // TODO Implement me.
    // if (this.convertFromPurchase && this.convertFromPurchase.amount) {
    //   return this.totalPrice - this.convertFromPurchase.amount;
    // }

    return calculateTotalPrice(contingents);
  }

  // Apply the best discount code for each contingent and calculate a new total
  let total = 0;
  let contingentsOrdered = orderByPrice(contingents);
  // Reset applied_amount per discount_code.
  for (var discountCodeIndex in applicableDiscountCodes) {
    applicableDiscountCodes[discountCodeIndex].applied_amount = 0;
    applicableDiscountCodes[discountCodeIndex].applied_count = 0;
  }
  for (var i = 0; i < contingentsOrdered.length; i++) {
    var contingent = contingentsOrdered[i];
    var count = contingent.count;
    var amount = count * contingent.price_gross;

    // Don't apply discount on contingents which are not valid
    if (count === 0) {
      continue;
    }

    // Check which discount code we can apply
    var discountCodes = filter(applicableDiscountCodes, function (dc) {
      return (
        dc.contingent_id === contingent.id ||
        (dc.event_id === contingent.event_id && !dc.contingent_id) ||
        (includes(contingent.page_ids, dc.page_id) &&
          !dc.event_id &&
          !dc.contingent_id)
      );
    });

    for (let discountCode of discountCodes) {
      let amount_to_apply = 0;

      if (
        discountCode.apply_automatically &&
        contingent.exclude_from_automatic_discount_codes
      ) {
        continue;
      }

      let count_to_apply = count;
      if (discountCode.max_ticket_count) {
        count_to_apply = Math.min(
          discountCode.max_ticket_count - discountCode.applied_count,
          count
        );
      }

      if (!count_to_apply) {
        continue;
      }

      let ticketPrice = amount / count;

      if (discountCode.type === "absolute") {
        amount_to_apply = Math.min(
          discountCode.amount - discountCode.applied_amount,
          ticketPrice * count_to_apply
        );
      } else {
        var discount_max_amount = count_to_apply * ticketPrice;
        amount_to_apply = (discount_max_amount * discountCode.amount) / 100;
      }

      discountCode.applied_amount += amount_to_apply;
      discountCode.applied_count += count_to_apply;

      let discountedPrice = Math.max(0, amount - amount_to_apply);
      amount = discountedPrice;
    }

    total += amount;
  }

  // if (this.convertFromPurchase && this.convertFromPurchase.conversion_fee) {
  //     total += this.convertFromPurchase.conversion_fee;
  // }

  // if (this.convertFromPurchase && this.convertFromPurchase.amount) {
  // 		return total = total - this.convertFromPurchase.amount;
  // }

  return total == 0 ? 0 : Math.max(1, total);
}
